module.exports = __webpack_public_path__ + "img/upload.4b8820aa.svg";